module.exports = __webpack_public_path__ + "static/img/aboutBg.d554519.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/aboutBg.jpg
// module id = lGwq
// module chunks = 1